//gettting lot details
//getting address geosuggest

export const GOTO_VIEW = '[View] Go to the view';
export const UPDATE_API_PROCESSING = '[View/API] Update API Processing Flag';
export const UPDATE_API_RETRY_COUNT = '[View/API] Update API Retry Count Flag';
export const UPDATE_API_ERROR = '[View/API] Update API Error Flag';
export const RESET_API_RETRY_COUNT = '[View/API] Reset API Retry Count Flag';
export const GET_STARTED = "[View] get started";
export const SET_VERIFIED = "[View] set verified"

export const goToView = (activeView) => ({
  type: GOTO_VIEW,
  payload: activeView
});

export const getStarted = () => ({
  type: GET_STARTED
})

export const setVerified = () => ({
  type: SET_VERIFIED

})



// WEBPACK FOOTER //
// ./src/redux/actions/ui.js